import { NavLink } from "react-router-dom";
import useUser from "../../hooks/useUser/useUser";
import { useAppSelector } from "../../store/hooks";
import { useTranslation } from "../../i18n/hooks/useTranslation";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import HeaderNavBarStyled from "./HeaderNavBarStyled";

const HeaderNavBar = (): JSX.Element => {
  const {
    user: { isLogged },
  } = useAppSelector((state) => state);

  const { logOutUser } = useUser();
  const { t } = useTranslation();

  return (
    <HeaderNavBarStyled className="header__navbar">
      <NavLink className="header-navbar__link" to="/">
        {t("navigation.home")}
      </NavLink>

      <NavLink className="header-navbar__link" to="/home">
        {t("navigation.structures")}
      </NavLink>

      {isLogged && (
        <NavLink className="header-navbar__link" to="add-new-structure">
          {t("navigation.add")}
        </NavLink>
      )}

      <NavLink className="header-navbar__link" to="map">
        {t("navigation.map")}
      </NavLink>

      {!isLogged ? (
        <NavLink className="header-navbar__link" to="login">
          {t("navigation.login")}
        </NavLink>
      ) : (
        <button
          onClick={logOutUser}
          type="button"
          className="header-navbar__link"
        >
          {t("navigation.logout")}
        </button>
      )}

      <LanguageSelector />
    </HeaderNavBarStyled>
  );
};

export default HeaderNavBar;
